import { SpecificCommerceLawsPage } from './SpecificCommerceLawsPage';

export const specificCommerceLawsRouter = {
  '/@/specific_commerce_laws': SpecificCommerceLawsPage, // TODO: path 를 적어주세요.
};
